import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import {
  Button,
  FormControlLabel,
  Checkbox,
  makeStyles,
  CircularProgress,
} from '@material-ui/core'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import GitHubIcon from '@material-ui/icons/GitHub'
import StackoverflowIcon from '../Images/icons8-stack-overflow-26.png'
import CheckUserProvider from '../AllHooks/CheckUserProvider'
import { checkIsUserExistsOrNot } from '../Backend/firebase/auth'
import CustomAlert from '../components/CustomAlert'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1': {
      fontSize: '14px',
    },
    '& .MuiFormControlLabel-root.makeStyles-root-16': {
      display: 'flex',
      alignItems: 'center',
    },
  },
}))

function PersonalDetailsForm({
  register,
  handleSubmit,
  activeStep,
  errors,
  steps,
  handleSkipRegistration,
  accessCode,
  setValue
}) {
  const classes = useStyles()
  const [isPersonOutsideFromNl, setIsPersonOutsideFromNl] = useState(true)
  const { userData } = CheckUserProvider()
  const [openNotify, setOpenNotify] = useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [checkEmail, setCheckEmail] = useState('')
  const [checkName, setCheckName] = useState('')
  const [checkZipCode, setCheckZipCode] = useState('')
  const [checkHouse, setCheckHouse] = useState('')
  const [isLoadingSkip, setIsLoadingSkip] = useState(false)
  const [errorsList, setErrorsList] = useState([])
  const [dateDoe, setDateDoe] = useState(new Date())

  const handleDoeChange = (e) => {
    setDateDoe(e.target.value)
  }

  const handleisPersonOutsideFromNLChange = (e) => {
    setIsPersonOutsideFromNl(!e.target.checked)
  }

  useEffect(() => {
    if (!isPersonOutsideFromNl) {
      setValue('zipcode', '');
      setValue('houseNr', '');
    }
  }, [isPersonOutsideFromNl]);

  const checkErrors = () => {
    var result = true
    var error = []
    if (!checkEmail) {
      setErrorsList((ele) => [...ele, 'Please enter the email address!'])
      result = false
    }

    if (!checkName) {
      setErrorsList((ele) => [...ele, 'Please enter the name!'])
      result = false
    }

    return result
  }

  const handleNextClick = async () => {
    var validation = checkErrors()
    if (validation) {
      var checkIfUserExists = await checkIsUserExistsOrNot(checkEmail)
      if (checkIfUserExists.length <= 0) {
        handleSubmit()
      } else {
        console.log('Bad')
        setNotificationMessage(
          'User with this email address is already exists, please try again with another email!!',
        )
        setOpenNotify(true)
        setAlertType('error')
      }
    }
  }

  const handleSkipBtn = async () => {
    setIsLoadingSkip(true)
    await handleSkipRegistration()
    setIsLoadingSkip(false)
  }

  // const handleFileChange = async (files) => {
  //     console.log('Profile Photo Name => ', files[0].name);
  //     const ref = await uploadImage('ncjshgrotro', files[0], files[0].name);
  //     console.log("Download Url => ", ref.getDownloadURL());
  // }

  return (
    <>
      <div className="row pt-1 pb-3 personalDetailsForm">
        <div className="col-md-8">
          <div className="form-group">
            <div className="row">
              <div className="col-md-3 col-sm-4 col-5 mb-2">
                <div className="form-group" style={{marginTop: '2px'}}>
                  <label className="login__textboxLabel">Your Title</label>
                  <select
                    className="form-select registerEmp__textbox"
                    aria-label="Default select example"
                    name="nameTitle"
                    ref={register}
                    defaultValue="Select Option"
                  >
                    <option value="Select Option">Select Option</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                  </select>
                </div>
              </div>

              <div className="col-md-9 col-sm-8 col-7">
                <div className="form-group">
                  <label className="login__textboxLabel">Your Name</label>{' '}
                  <span
                    className="text-danger"
                    style={{
                      fontSize: '18px',
                      fontWeight: '900',
                      marginLeft: '3px',
                    }}
                  >
                    *
                  </span>
                  <input
                    type="text"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.name,
                    })}
                    name="name"
                    placeholder="Name"
                    autoComplete="off"
                    onChange={(e) => setCheckName(e.target.value)}
                    ref={register({ required: 'Please enter your name!' })}
                  />
                  <small className="form-text text-danger">
                    {errors.name && errors.name.message}
                  </small>
                  {!checkName && errorsList.length > 0 ? (
                    <small className="form-text text-danger">
                      Please enter the name!
                    </small>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="form-group">
            <label className="login__textboxLabel">Email Address</label>{' '}
            <span
              className="text-danger"
              style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}
            >
              *
            </span>
            <input
              type="email"
              className={classNames('form-control registerEmp__textbox', {
                'is-invalid': errors.email,
              })}
              name="email"
              placeholder="Email Address"
              autoComplete="none"
              onChange={(e) => setCheckEmail(e.target.value)}
              ref={register({ required: 'Please enter your email address!' })}
            />
            <small className="form-text text-danger">
              {errors.email && errors.email.message}
            </small>
            {!checkEmail && errorsList.length > 0 ? (
              <small className="form-text text-danger">
                Please enter the email address!
              </small>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="form-group">
            <label className="login__textboxLabel">
              Date of birth (non mandatory)
            </label>
            {/* <input
              type="date"
              max="9999-12-31"
              className={classNames('form-control registerEmp__textbox', {
                'is-invalid': errors.doe,
              })}
              name="doe"
              placeholder="dd-MM-yyyy"
              autoComplete="none"
              ref={register}
            /> */}
            <DatePickerComponent
                  id="doe"
                  value={dateDoe}
                  cssClass="e-outline"
                  onChange={(e) => handleDoeChange(e)}
                  ref={register}
                  format="dd/mm/yyyy"
                  className={classNames('form-control registerEmp__textbox', {
                    'is-invalid': errors.doe,
                  })}
                  name="doe"
                />
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="form-group">
            <label className="login__textboxLabel">
              Phone Number (non mandatory)
            </label>
            <input
              type="text"
              className={classNames('form-control registerEmp__textbox', {
                'is-invalid': errors.phoneNumber,
              })}
              name="phoneNumber"
              placeholder="Phone Number"
              autoComplete="none"
              ref={register}
            />
          </div>
        </div>
        <div className="col-md-4 mb-2">
          <div className="form-group">
            <label className="login__textboxLabel">
              Your Photo (non mandatory)
            </label>
            <input
              type="file"
              className={classNames('form-control registerEmp__textbox', {
                'is-invalid': errors.profilePhoto,
              })}
              name="profilePhoto"
              placeholder="Profile Photo"
              accept=".png,.jpg,.jpeg"
              ref={register}
            />
          </div>
        </div>
        <div className="col-md-12 mb-2">
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="login__textboxLabel">Zipcode</label>{' '}
                <input
                  type="text"
                  className={classNames('form-control registerEmp__textbox', {
                    'is-invalid': errors.zipcode,
                  })}
                  name="zipcode"
                  placeholder="Zipcode"
                  autoComplete="none"
                  onChange={(e) => setCheckZipCode(e.target.value)}
                  ref={register({
                    required: isPersonOutsideFromNl
                      ? 'Please enter zipcode!'
                      : false,
                  })}
                />
                <small className="form-text text-danger">
                  {errors.zipcode && errors.zipcode.message}
                </small>
                {isPersonOutsideFromNl ? (
                  !checkZipCode && errorsList.length > 0 ? (
                    <small className="form-text text-danger">
                      Please enter the zipcode!
                    </small>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className="col-md-4 mb-2">
              <div className="form-group">
                <label className="login__textboxLabel">Your CV (non mandatory)</label>
                <input
                  type="file"
                  className={classNames('form-control registerEmp__textbox', {
                    'is-invalid': errors.cvDocument,
                  })}
                  name="cvDocument"
                  placeholder="Your CV"
                  accept=".docs,.doc,.pdf"
                  ref={register}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row personalDetailsSocialData">
        <div className="col-md-12 mb-2">
          <h4 className="personalDetailsSocialData__title">
            Your social media
          </h4>
        </div>
        <div className="col-md-6 mb-1">
          <div className="form-group">
            <label className="login__textboxLabel">
              Twitter account (non mandatory)
            </label>
            <div className="input-group mb-3">
              <span
                className="input-group-text twitterIconStyle"
                id="basic-addon1"
              >
                @
              </span>
              <input
                type="text"
                aria-label="twitterLink"
                aria-describedby="basic-addon1"
                className={classNames('form-control registerEmp__textbox', {
                  'is-invalid': errors.twitterLink,
                })}
                name="twitterLink"
                autoComplete="none"
                ref={register}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-1">
          <div className="form-group">
            <label className="login__textboxLabel">
              LinkedIn account (non mandatory)
            </label>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                <LinkedInIcon />
              </span>
              <input
                type="text"
                aria-label="linkedInLink"
                aria-describedby="basic-addon1"
                className={classNames('form-control registerEmp__textbox', {
                  'is-invalid': errors.linkedInLink,
                })}
                name="linkedInLink"
                autoComplete="none"
                ref={register}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-1">
          <div className="form-group">
            <label className="login__textboxLabel">
              Facebook account (non mandatory)
            </label>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                <FacebookIcon />
              </span>
              <input
                type="text"
                aria-label="facebookLink"
                aria-describedby="basic-addon1"
                className={classNames('form-control registerEmp__textbox', {
                  'is-invalid': errors.facebookLink,
                })}
                name="facebookLink"
                autoComplete="none"
                ref={register}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-1">
          <div className="form-group">
            <label className="login__textboxLabel">
              Instagram account (non mandatory)
            </label>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                <InstagramIcon />
              </span>
              <input
                type="text"
                aria-label="instagramLink"
                aria-describedby="basic-addon1"
                className={classNames('form-control registerEmp__textbox', {
                  'is-invalid': errors.instagramLink,
                })}
                name="instagramLink"
                autoComplete="none"
                ref={register}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-1">
          <div className="form-group">
            <label className="login__textboxLabel">
              Stack Overflow profile (non mandatory)
            </label>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                <img
                  src={StackoverflowIcon}
                  alt="Stack OverflowIcon"
                  className="stackoverflowStyle"
                />
              </span>
              <input
                type="text"
                aria-label="stackOverFlowLink"
                aria-describedby="basic-addon1"
                className={classNames('form-control registerEmp__textbox', {
                  'is-invalid': errors.stackOverFlowLink,
                })}
                name="stackOverFlowLink"
                autoComplete="none"
                ref={register}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-1">
          <div className="form-group">
            <label className="login__textboxLabel">
              Github profile (non mandatory)
            </label>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                <GitHubIcon />
              </span>
              <input
                type="text"
                aria-label="githubLink"
                aria-describedby="basic-addon1"
                className={classNames('form-control registerEmp__textbox', {
                  'is-invalid': errors.githubLink,
                })}
                name="githubLink"
                autoComplete="none"
                ref={register}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row pb-3">
        <div className="col-md-12 text-center mt-2">
          {/* {(userData && userData.provider !== "password") ?
                        <Button className="multiStepRegister__btnLogin multiStepRegister__skipBtn"
                            variant="contained" onClick={handleSkipBtn}>
                            {isLoadingSkip ? <CircularProgress size={18} /> : 'Skip Form Submission'}
                        </Button> : accessCode ? <Button className="multiStepRegister__btnLogin multiStepRegister__skipBtn"
                            variant="contained" onClick={handleSkipBtn}>
                            {isLoadingSkip ? <CircularProgress size={18} /> : 'Skip Form Submission'}
                        </Button> : ''
                    } */}
          {(userData && userData.provider !== 'password') || accessCode ? (
            <Button
              className="multiStepRegister__btnLogin multiStepRegister__skipBtn"
              variant="contained"
              onClick={handleSkipBtn}>
              {isLoadingSkip ? (
                <CircularProgress size={18} />
              ) : (
                'Skip Form Submission'
              )}
            </Button>
          ) : (
            ''
          )}
          <Button
            onClick={handleNextClick}
            className="multiStepRegister__btnLogin"
            variant="contained"
            disabled={activeStep === steps.length ? true : false}
          >
            {activeStep === steps.length
              ? 'All Steps Complete'
              : activeStep === steps.length - 1
              ? 'Register'
              : 'Next'}
          </Button>
        </div>
      </div>

      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default PersonalDetailsForm
